import * as config from '@/constants/config'
import ImageURIHelper from "@/helpers/ImageURIHelper";

import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";

pdfMake.vfs = pdfFonts.pdfMake.vfs;

//Based on A3/72dpi page size (swaped due to landscape orientation)
const pageWidth = 1191;
const pageHeight = 842;

const nbPerRow = 10;
const nbPerColumn = 9;

var initDay = new Date()

var dd = {
    pageOrientation: 'landscape',
    pageSize: {
        width: pageWidth,
        height: pageHeight
    },
    content: [{
            text: 'Timepieces list FY' + String(initDay.getFullYear()).substring(2),
            style: 'header'
        },
        {
            text: 'Created on: ' + String(initDay.getDate()).padStart(2, '0') + '.' + String(initDay.getMonth() + 1).padStart(2, '0') + '.' + initDay.getFullYear() + ' - ' + String(initDay.getHours()).padStart(2, '0') + ':' + String(initDay.getMinutes()).padStart(2, '0'),
            style: 'subheader'
        },
        {
            table: {
                widths: '33%',
                heights: pageHeight * 0.2,
                dontBreakRows: true,

                body: []
            },
            layout: 'noBorders'
        }
    ],
    styles: {
        header: {
            fontSize: 15,
            bold: true,
        },

        subheader: {
            fontSize: 10,
            margin: [0, 0, 0, 15]
        },

        watchName: {
            margin: [0, pageHeight * 0.2 * 0.15, 0, 0],
            fontSize: 12,
            bold: true,
            alignment: 'center',
        },

        numberTable: {
            fontSize: 9,
            alignment: 'center',
        },

        booked: {
            fillColor: '#808080'
        },

        noNumberFrame: {
            fillColor: '#FFFFFF'
        },

        pendingRequest: {
            fillColor: '#FFA500'
        }
    },
    defaultStyle: {
        // alignment: 'justify'
    }
};

const templateSoldOut = {
    stack: [{
            text: 'Sold Out',
            color: 'red',
            fontSize: 20,
            relativePosition: {}
        },
        {
            canvas: [{
                type: 'rect',
                x: -2,
                y: -1,
                w: 80,
                h: 25,
                lineColor: 'red',
            }]
        }
    ],
    relativePosition: {
        x: pageWidth * 0.020,
        y: -pageHeight * 0.14
    }
};

const templateToInsert = {
    layout: 'noBorders',
    table: {
        widths: ['35%', '*'],
        body: [
            [{
                    stack: [{
                            image: '',
                            fit: [pageWidth * 0.33 * 0.32, pageHeight * 0.2 * 0.9],
                            margin: [10, 0, 0, 0]
                        },
                        {
                            style: 'watchName',
                            text: ''
                        },
                    ]
                },
                {
                    style: 'numberTable',
                    table: {
                        widths: '*',
                        body: [],
                    }
                }
            ]
        ]
    }
};

const templateTableCell = {
    style: '',
    text: ''
};

const templateBTQ = {
    stack: [{
            text: 'BTQ',
            relativePosition: {
                x: -pageWidth * 0.009,
                y: -pageHeight * 0.008
            }
        },
        {
            canvas: [{
                type: 'ellipse',
                x: 0,
                y: 0,
                r1: 18,
                r2: 18
            }, ]
        }
    ],
    relativePosition: {
        x: pageWidth * 0.08,
        y: -pageHeight * 0.04
    }
};

function getBase64Image(watch) {
    return new Promise((resolve, reject) => {
        var img = new Image();
        img.setAttribute('crossOrigin', 'anonymous');
        img.onload = function () {
            var canvas = document.createElement("canvas");
            canvas.width = img.width;
            canvas.height = img.height;
            var ctx = canvas.getContext("2d");
            ctx.drawImage(img, 0, 0);
            resolve(canvas.toDataURL("image/jpg"));
        }
        img.onerror = function () {
            reject("Can't retrieve image")
        }
        
        img.src = ImageURIHelper.BuildImageSource(watch.Name + config.ThumbnailSuffix, config.ThumbExt) + '?t=0';
    })
}

async function insertWatchInTable(tableConcerned, watch, index) {
    var toInsert = JSON.parse(JSON.stringify(templateToInsert));
    toInsert.table.body[0][0].stack[0].image = await getBase64Image(watch)
    toInsert.table.body[0][0].stack[1].text = watch.Name;
    tableConcerned[index] = toInsert;
}

function chooseStyle(watch, index, cell) {
    if (index > watch.Pieces) {
        cell.style = 'noNumberFrame';
        cell.border = [false, false, false, false];
        cell.text = ' ';
    } else if (watch.Availability[index - 1].StatusId == 3) {
        cell.style = 'booked';
    } else if (watch.Availability[index - 1].StatusId == 2) {
        cell.style = 'pendingRequest';
    }
}

function fillTable(table, watch, nbOffset = 0) {
    var i, j, number;
    var tmpCell;
    var toPush;

    for (j = 0; j < nbPerColumn + !!nbOffset; j++) {
        toPush = [];
        for (i = 1; i <= nbPerRow; i++) {
            tmpCell = Object.create(templateTableCell);
            number = i + nbOffset + j * 10;

            tmpCell.text = number;
            chooseStyle(watch, number, tmpCell);

            toPush.push(tmpCell)
        }
        table.push(toPush);
    }
}

function isSoldOut(watch) {
    var bookedPieces = 0;

    watch.Availability.forEach(element => {
        if (element.StatusId == 3) {
            bookedPieces++;
        }
    });

    return watch.Pieces == bookedPieces;
}

async function generateTemplate(watches, table, columnsNb) {
    var currentWatch;
    var offset = 0;

    for (var i = 0; i < watches.length; i++) {
        currentWatch = watches[i];

        await generateWatchTable(table, i + offset, currentWatch, columnsNb)

        if (currentWatch.Pieces > nbPerRow * nbPerColumn) {
            var toAdd = Math.floor(currentWatch.Pieces / (nbPerRow * (nbPerColumn + 1)));

            for (var j = 1; j <= toAdd; j++) {
                await generateWatchTable(table, i + j + offset, currentWatch, columnsNb, nbPerRow * nbPerColumn + ((j - 1) * (nbPerRow * (nbPerColumn + 1))))
            }

            offset += toAdd
        }
    }
}

async function generateWatchTable(table, cellId, currentWatch, columnsInTable, nbOffset) {
    var currentRow = Math.floor(cellId / columnsInTable);
    var currentColumn = cellId % columnsInTable;

    if (currentColumn === 0) {
        table.push(Array(columnsInTable).fill(''));
    }

    await insertWatchInTable(table[currentRow], currentWatch, currentColumn)

    fillTable(table[currentRow][currentColumn].table.body[0][1].table.body, currentWatch, nbOffset);

    /*
    if (isSoldOut(currentWatch)) {
        table[currentRow][currentColumn].table.body[0][0].stack.push(JSON.parse(JSON.stringify(templateSoldOut)));
    }
    */

    if (currentWatch.Btq) {
        table[currentRow][currentColumn].table.body[0][0].stack.push(JSON.parse(JSON.stringify(templateBTQ)));
    }

}

export default {
    ConvertPDFWatches: function (watches) {
        return new Promise(function (resolve, reject) {
            var template = JSON.parse(JSON.stringify(dd));

            generateTemplate(watches, template.content[2].table.body, 3)
                .then(r => {
                    var day = new Date()

                    template.content[1].text = 'Created on: ' + String(day.getDate()).padStart(2, '0') + '.' + String(day.getMonth() + 1).padStart(2, '0') + '.' + day.getFullYear() + ' - ' + String(day.getHours()).padStart(2, '0') + ':' + String(day.getMinutes()).padStart(2, '0')

                    pdfMake.createPdf(template).download('Limited Numbers products - ' + String(day.getDate()).padStart(2, '0') + '/' + String(day.getMonth() + 1).padStart(2, '0') + '/' + day.getFullYear() + '-' + String(day.getHours()).padStart(2, '0') + ':' + String(day.getMinutes()).padStart(2, '0') + '.pdf');

                    resolve(0)
                })
                .catch(e => reject(e))

        });
    }
}